import React from "react";
import './TextArea.scss'



const TextArea = ({className, type="text",titulo = "title", obligatorio = false, placeholder, id, onChange,value,disabled ,style}) => {
    return (
        <div className="TextArea" style={style}>
            <div className="contenedorTitulo">
                {
                    obligatorio ?
                    <>
                            <div className="obligatorio">*</div>
                        </>:null
                }
                <div className="titulo">{titulo}</div>
            </div>
            <textarea className={`${className}`} type={type} disabled={disabled} value={value} id={id} onChange={onChange} placeholder={placeholder} />
        </div>
    )
}
export default TextArea